import {
  getAttachments,
  getBoardName,
  getBoards,
  getBoardsWithSameWorkflowId,
  getDownloadAttachment,
  getLabels,
} from "../services/apiBoards";
import { getCommentsBoard } from "../services/apiComment";
import { getWorklogHistory } from "../services/apiWorklog";
import { hasQueryValue, useMappedQuery } from "./queryUtils";

export function useBoards() {
  return useMappedQuery({
    queryKey: ["boards"],
    queryFn: getBoards,
    dataKey: "boards",
  });
}

export function useBoardName(id) {
  return useMappedQuery({
    queryKey: ["boardName", id],
    queryFn: () => getBoardName(id),
    enabled: hasQueryValue(id),
    dataKey: "boardName",
  });
}

export function useAttachments(boardId) {
  return useMappedQuery({
    queryKey: [`attachments-${boardId}`],
    queryFn: () => getAttachments(boardId),
    dataKey: "attachments",
  });
}

export function useDownloadAttachment(attachmentId) {
  return useMappedQuery({
    queryKey: ["AttachmentDownload", attachmentId],
    queryFn: () => getDownloadAttachment(attachmentId),
    dataKey: "downloadAttachment",
  });
}

export function useLabels(boardId) {
  return useMappedQuery({
    queryKey: ["labels", boardId],
    queryFn: () => getLabels(boardId),
    dataKey: "labels",
  });
}

export function useBoardsWithSameWorkflow(boardId) {
  return useMappedQuery({
    queryKey: ["boardNameWithSameWorkflow", boardId],
    queryFn: () => getBoardsWithSameWorkflowId(boardId),
    dataKey: "board",
  });
}

export function useCommentBoard(id, milestoneId) {
  return useMappedQuery({
    queryKey: ["commentBoard", id, milestoneId],
    queryFn: () => getCommentsBoard(id, milestoneId),
    dataKey: "commentBoard",
  });
}

export function useBoardWorklogs({ user, id, dateRange, milestone }) {
  return useMappedQuery({
    queryKey: ["boardWorklogs", id, user, dateRange, milestone],
    queryFn: () => getWorklogHistory(user, id, dateRange, milestone),
    enabled: hasQueryValue(id),
    dataKey: "boardWorklog",
  });
}
